import { gql } from "@apollo/client";

export const getAgendaCompany = gql/* GraphQL */ `
query GetAgendaCompany($id: ID!) {
  getAgendaCompany(id: $id) {
    comId
    id
    name
    __typename
  }
}
`;

export const createAgendaPost = gql/* GraphQL */ `
mutation CreateAgendaPost(
  $condition: ModelAgendaPostConditionInput
  $input: CreateAgendaPostInput!
) {
  createAgendaPost(condition: $condition, input: $input) {
    comId
    room
    deleted
    description
    updatedAt
    userId
    __typename
  }
}
`;

export const createAgendaPostByComId = gql/* GraphQL */ `mutation CreateAgendaPostByComId(
  $comId: ID!
  $createdAt: AWSDateTime
  $deleted: Boolean
  $description: String
  $image: String
  $postId: ID!
  $room: String
  $updatedAt: AWSDateTime
  $userId: ID
  $username: String
) {
  createAgendaPostByComId(
    comId: $comId
    createdAt: $createdAt
    deleted: $deleted
    description: $description
    image: $image
    postId: $postId
    room: $room
    updatedAt: $updatedAt
    userId: $userId
    username: $username
  ) {
    com {
      account_type
      address
      comId
      createdAt
      customer_id
      image
      name
      phoneNumber
      planId
      subscriptionId
      suspended
      type
      updatedAt
      userId
      __typename
    }
    comId
    createdAt
    deleted
    description
    image
    postId
    room
    updatedAt
    user {
      FCMtoken
      comId
      createdAt
      email
      firstName
      friday
      hours
      image
      isConfirmed
      language
      lastName
      monday
      night
      password
      phoneNumber
      profileOwner
      readedAt
      role
      saturday
      sunday
      suspended
      thursday
      timezone
      tuesday
      type
      updatedAt
      userId
      username
      wednesday
      __typename
    }
    userId
    username
    __typename
  }
}
`;

export const updateAgendaPost = gql/* GraphQL */ `
mutation UpdateAgendaPost(
  $condition: ModelAgendaPostConditionInput
  $input: UpdateAgendaPostInput!
) {
  updateAgendaPost(condition: $condition, input: $input) {
    comId
    createdAt
    deleted
    description
    postId
    updatedAt
    userId
    __typename
  }
}
`;